// Resolvers
import { fetchLocalizationConfigurationResolver } from '../resolvers/localization.resolver';
// Constants
import { URL_PUBLIC_CHAT_OPI, URL_PUBLIC_CHAT_SURVEY } from 'constants/storage/storage.constants';
// Types
import {
  LocalizationBuilderHandlersType,
  LocalizationBuilderReturnHandlersType,
} from './types/localization.handlers.type';

const fetchLocalizationConfigurationHandler = async ({
  setFetching,
  setLocalization,
}: LocalizationBuilderHandlersType): Promise<any> => {
  setFetching(true);
  const [configuration] = await fetchLocalizationConfigurationResolver();

  setLocalization({});
  configuration && setLocalization(configuration);
  localStorage.setItem(URL_PUBLIC_CHAT_SURVEY, configuration?.params?.url_public_chat_survey);
  localStorage.setItem(URL_PUBLIC_CHAT_OPI, configuration?.params?.url_public_chat_opi);
  setFetching(false);
};

const LocalizationHandlers = (
  props: LocalizationBuilderHandlersType
): LocalizationBuilderReturnHandlersType => ({
  handleFetchLocalizationConfiguration: () => fetchLocalizationConfigurationHandler(props),
});

export default LocalizationHandlers;
